var $ = require('jquery');

module.exports = {
  init: function () {
    var t = this.number;

    $.extend(
      t,
      {
        format: {
          decimal: /\./,
          grouping: /(\d\d|\d(?=\d{4}))(?=(\d{3})+([^\d]|$)())/g
        },

        unformat: {
          decimal: new RegExp('[\\.\\' + t.decimal + ']'),
          grouping: new RegExp('\\' + t.grouping, 'g')
        }
      }
    );
  },

  destroy: function () {
  },

  // TODO: Надо сделать выбор.
  abbr: 'ru',

  number: {decimal: ',', grouping: ' '},

  date: 'dd.mm.yy',

  month: [
    {abbr: 'янв', name: 'Январь', name_genitive: 'января'},
    {abbr: 'фев', name: 'Февраль', name_genitive: 'февраля'},
    {abbr: 'мар', name: 'Март', name_genitive: 'марта'},
    {abbr: 'апр', name: 'Апрель', name_genitive: 'апреля'},
    {abbr: 'мая', name: 'Май', name_genitive: 'мая'},
    {abbr: 'июн', name: 'Июнь', name_genitive: 'июня'},
    {abbr: 'июл', name: 'Июль', name_genitive: 'июля'},
    {abbr: 'авг', name: 'Август', name_genitive: 'августа'},
    {abbr: 'сен', name: 'Сентябрь', name_genitive: 'сентября'},
    {abbr: 'окт', name: 'Октябрь', name_genitive: 'октября'},
    {abbr: 'ноя', name: 'Ноябрь', name_genitive: 'ноября'},
    {abbr: 'дек', name: 'Декабрь', name_genitive: 'декабря'}
  ],

  first_day: 1,

  weekday: [
    {abbr: 'Пн', name: 'Понедельник'},
    {abbr: 'Вт', name: 'Вторник'},
    {abbr: 'Ср', name: 'Среда'},
    {abbr: 'Чт', name: 'Четверг'},
    {abbr: 'Пт', name: 'Пятница'},
    {abbr: 'Сб', name: 'Суббота'},
    {abbr: 'Вс', name: 'Воскресенье'}
  ],

  prev_month: 'Предыдущий',

  next_month: 'Следующий',

  yesterday: 'Вчера',

  today: 'Сегодня',

  tomorrow: 'Завтра'
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/locale.js
 ** module id = 49
 ** module chunks = 0
 **/